import { type FC, type TdHTMLAttributes, useContext } from 'react';

import { TableContext } from '../table-context';
import { Channel, type ChannelProps } from './ui/channel/channel';

export type TCellChannelProps = TdHTMLAttributes<HTMLTableCellElement> & {
  index?: number;
  city?: string;
  channel: ChannelProps;
};

export const TCellChannel: FC<TCellChannelProps> = ({ channel, city, index, ...props }) => {
  const { columnsConfiguration } = useContext(TableContext);

  const column = index === undefined ? null : columnsConfiguration[index];
  const width = column?.width;

  return (
    <td style={{ width }} {...props}>
      <Channel size="sm" {...channel} />
    </td>
  );
};
